import React from "react";
import MenuItem from "@mui/material/MenuItem";
import Box from "@mui/material/Box";
// import Button from "@mui/material/Button";
// import Typography from "@mui/material/Typography";

import { dataType } from "../../../components/GenericList/GenericList";
import { Form } from "react-final-form";
import { Select } from "mui-rff";
import { theme } from "../../../theme";
import FdTypography from "../../../components/UIComponents/Typography/FdTypography";
import FdButton from "../../../components/UIComponents/Button/FdButton";
import { IFieldsTemplate, attendeeFieldsTemplate, getFieldLabel, reservationFieldsTemplate, sessionFieldsTemplate } from "../../../helpers/constants";

const classes = {
  baseWrapper: {
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "center",
    height: "calc(100vh - 150px)",
  },
  fieldsWrapper: {
    textAlign: "left",
    backgroundColor: theme.palette.grey[600],
    padding: "30px 30px 15px 30px",
    width: "400px",
    borderRadius: "5px",
    overflow: "auto",
    flexGrow: 1,
  },
  backButton: {
    fontSize: "12px",
    textDecoration: "underline",
    "&:hover": {
      backgroundColor: "transparent",
      textDecoration: "none",
    },
  },
} as const;

export interface IProps {
  initialMap?: any;
  csvType: dataType;
  csvData: any[]; // the imported csv data array
  onFormSubmit: Function;
  onCancel: Function;
}

type rowData = {
  [index: string]: string;
};

interface IFieldTemplates {
  [index: string]: IFieldsTemplate;
}

const fieldTemplates: IFieldTemplates = {
  [dataType.ATTENDEES]: attendeeFieldsTemplate,
  [dataType.SESSIONS]: sessionFieldsTemplate,
  [dataType.RESERVATIONS]: reservationFieldsTemplate,
};

function CSVMappingForm({
  csvType,
  csvData,
  onCancel,
  onFormSubmit,
  initialMap,
}: IProps) {
  const templateFields = fieldTemplates[csvType];
  let submit: Function;

  const onSubmit = async (values: any) => {
    onFormSubmit(values);
  };

  const getCSVColumns = () => {
    return Object.keys(csvData[0]).map((key) => {
      return (
        <MenuItem key={key} value={key}>
          {key}
        </MenuItem>
      );
    });
  };

  async function validate(values: any) {
    for (const field of Object.values(templateFields)) {
      if (!values[field]) {
        return { [field]: "Required" };
      }
    }

    return;
  }

  // try to prefill the mapping form, use the already selected map or try to use the csv columns
  const getInitialValues = () => {
    const initialValues: rowData = {};
    if (initialMap) {
      return initialMap;
    }

    Object.values(templateFields).forEach((field, index) => {
      initialValues[field] = Object.keys(csvData[0])[index] || "";
    });

    return initialValues;
  };

  const csvColumns = getCSVColumns();
  const initialValues = getInitialValues();
  return (
    <Box sx={classes.baseWrapper}>
      <Box>
        <FdTypography
          label="CSV Import Match Fields"
          variant="h2"
          component="h2"
          mb="30px"
        />
      </Box>

      <Box sx={classes.fieldsWrapper}>
        <Form
          initialValues={initialValues}
          onSubmit={onSubmit}
          validate={validate}
          render={({ handleSubmit, values }) => {
            submit = handleSubmit;
            return (
              <form onSubmit={handleSubmit} noValidate>
                {Object.values(templateFields).map((field) => (
                  <Box marginBottom="15px" key={field}>
                    <Select
                      required
                      name={field}
                      label={getFieldLabel(field)}
                      disableUnderline
                      variant="standard"
                    >
                      {csvColumns}
                    </Select>
                  </Box>
                ))}
              </form>
            );
          }}
        />
      </Box>

      <Box textAlign="center">
        <Box marginTop="20px" marginBottom="10px">
          <FdButton
            variant="contained"
            color="primary"
            size="medium"
            onClick={(e: any) => {
              e.stopPropagation();
              submit();
            }}
            ButtonName="Continue"
          />
        </Box>
        <FdButton variant="text" sx={classes.backButton} onClick={() => onCancel()} ButtonName="Go back" />
      </Box>
    </Box>
  );
}

export default CSVMappingForm;
